import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as CrudServices from "../../../../../service/crudServices";
import * as DeliveryAssociateServices from "../../../../../service/master/DeliveryAssociateServices";
import { useSelector } from "react-redux";
import { API_DELIVERY_ASSOCIATE } from "../../../../../api/contractAPI.api";
import Breadcumbs from "../../../../../component/page-components/breadcumbs/breadcumbs";
import HeaderPages from "../../../../../component/page-components/pages-header";
import { ROUTES } from "../../../../../constant/routeConstant";
import TabDriverProfileOutsources from "./outsources/tab-1/TabDriverProfileOutsources";
import TabFleetDetailOutsources from "./outsources/tab-2/TabFleetDetailOutsources";
import dayjs from "dayjs";
import NotifFailedSaved from "../../../../../component/modal/NotifFailedSaved";
import NotifAddSuccess from "../../../../../component/modal/NotifAddSuccess";
import { validationDA } from "../validationDA";
import { t } from "i18next";

const MainEditDeliveryAssociate = () => {
  const { token } = useSelector((state) => state.auth);

  const location = useLocation();
  const navigate = useNavigate();

  const [depotId, setDepotId] = useState();
  const [driverId, setDriverId] = useState(0);
  const [nameDA, setNameDA] = useState();
  const [FormInput, setFormInput] = useState();
  const [FormInputDate, setFormInputDate] = useState();
  const [FormInputShiftStart, setFormInputShiftStart] = useState();
  const [FormInputShiftEnd, setFormInputShiftEnd] = useState();
  const [valueDayOff, setValueDayOff] = useState();
  const [FormInputNumber, setFormInputNumber] = useState();
  const [FormInputPhone, setFormInputPhone] = useState();
  const [countryId, setCountryId] = useState();
  const [provinceId, setProvinceId] = useState();
  const [districtId, setDistrictId] = useState();
  const [subDistrictId, setSubDistrictId] = useState();
  const [urbanVillageId, setUrbanVillageId] = useState();
  const [postalCodeId, setPostalCodeId] = useState();
  const [skillSetId, setSkillSetId] = useState();
  const [tempCategoryId, setTempCategoryId] = useState();
  const [PhotoDriver, setPhotoDriver] = useState([]);
  const [PhotoDriverLicense, setDriverLicensePhoto] = useState([]);
  const [titleId, setTitleId] = useState();
  const [gender, setGender] = useState();
  const [licenseTypeId, setLicenseTypeId] = useState();
  const [maritalStatus, setMaritalStatus] = useState();
  const [updatedAt, setUpdatedAt] = useState();

  const [tab, setTab] = useState(1);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFailed, setMessageFailed] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [messagesSuccess, setMessagesSuccess] = useState("");

  const btnBack = useCallback(() => {
    navigate(location?.state?.prevPage, {
      state: {
        id: location?.state?.id,
        prevPage: location?.pathname,
      },
    });
  }, [navigate, location?.state?.prevPage]);

  const getDetailDeliveryAssociate = useCallback(async () => {
    const { ok, data } = await CrudServices.getDetail(
      token,
      API_DELIVERY_ASSOCIATE,
      location?.state?.id
    );
    if (ok && data) {
      const nameDA = `${
        data?.driver_profile?.first_name ? data?.driver_profile?.first_name : ""
      } ${
        data?.driver_profile?.last_name ? data?.driver_profile?.last_name : ""
      } ${
        data?.fleet_detail?.vehicle_type ? data?.fleet_detail?.vehicle_type : ""
      }`;

      const InitPhone = data?.driver_profile?.phone
        ? data?.driver_profile?.phone.split("-")
        : "";

      const InitEmergencyPhone = data?.driver_profile?.emergency_contact_no_hp
        ? data?.driver_profile?.emergency_contact_no_hp.split("-")
        : "";

      // Init FormInput
      const InitFormInput = {
        first_name: data?.driver_profile?.first_name,
        last_name: data?.driver_profile?.last_name,
        username: data?.driver_profile?.username,
        nik: data?.driver_profile?.nik,
        email: data?.driver_profile?.email,
        birth_place: data?.driver_profile?.birth_place,
        emergency_contact_name: data?.driver_profile?.emergency_contact_name,
        emergency_contact_relationship:
          data?.driver_profile?.emergency_contact_relationship,
        emergency_contact_address:
          data?.driver_profile?.emergency_contact_address,
        address: data?.driver_profile?.address,
        neighbour: data?.driver_profile?.neighbour,
        hamlet: data?.driver_profile?.hamlet,
        driving_license_no: data?.fleet_detail?.license_number,
        vehicle_type: data?.fleet_detail?.vehicle_type,
        model: data?.fleet_detail?.model,
        vehicle_no: data?.fleet_detail?.vehicle_no,
        license_id: data?.fleet_detail?.license_id,
        daily_salary:Number(data?.driver_profile?.daily_salary),
        hourly_salary:data?.driver_profile?.hourly_salary,
        total_range_distance:data?.fleet_detail?.total_range_distance
      };

      // Init Form Input Phone
      const InitFormInputPhone = {
        phone: InitPhone && InitPhone.length ? InitPhone[1] : "",
        emergency_contact_no_hp:
          InitEmergencyPhone && InitEmergencyPhone.length
            ? InitEmergencyPhone[1]
            : "",
      };

      // InitFormDate
      const InitFormInputDate = {
        date_of_birth: data?.driver_profile?.date_of_birth
          ? dayjs(data?.driver_profile?.date_of_birth)
          : null,
        license_validity: data?.fleet_detail?.license_validity
          ? dayjs(data?.fleet_detail?.license_validity)
          : null,
      };

      const ShiftStartTime = data?.driver_profile?.shift_start_time.split(":");
      // InitFormShiftStart
      const InitFormShiftStart = {
        shift_start_hours: ShiftStartTime[0],
        shift_start_minutes: ShiftStartTime[1],
      };

      const ShiftEndTime = data?.driver_profile?.shift_end_time.split(":");
      // Init Form Shift End
      const InitFormShiftEnd = {
        shift_end_hours: ShiftEndTime[0],
        shift_end_minutes: ShiftEndTime[1],
      };

      // Init Value Day Off
      const ValDayOff = data?.driver_profile?.day_off
        ? data?.driver_profile?.day_off.split(",")
        : null;

      // Init Input Number
      const InitFormInputNumber = {
        max_order_unit: data?.fleet_detail?.max_order_unit,
        max_order_weight: data?.fleet_detail?.max_order_weight,
        max_order_volume: data?.fleet_detail?.max_order_volume,
        min_order_unit: data?.fleet_detail?.min_order_unit,
        min_order_weight: data?.fleet_detail?.min_order_weight,
        min_order_volume: data?.fleet_detail?.min_order_volume,
        fixed_cost: data?.fleet_detail?.fixed_cost
          ? Number(data?.fleet_detail?.fixed_cost)
          : 0,
        variable_cost: data?.fleet_detail?.variable_cost
          ? Number(data?.fleet_detail?.variable_cost)
          : 0,
        transporter_time_cost: data?.fleet_detail?.transporter_time_cost
          ? Number(data?.fleet_detail?.transporter_time_cost)
          : 0,
        waiting_time_cost: data?.fleet_detail?.waiting_time_cost
          ? Number(data?.fleet_detail?.waiting_time_cost)
          : 0,
      };
      setTitleId(data?.driver_profile?.title);
      setDriverId(data?.driver_profile?.driver_id);
      setGender(data?.driver_profile?.gender);
      setNameDA(nameDA);
      setFormInput(InitFormInput);
      setFormInputDate(InitFormInputDate);
      setFormInputShiftStart(InitFormShiftStart);
      setFormInputShiftEnd(InitFormShiftEnd);
      setFormInputPhone(InitFormInputPhone);
      setValueDayOff(ValDayOff);
      setFormInputNumber(InitFormInputNumber);
      setCountryId(data?.driver_profile?.country_id);
      setProvinceId(data?.driver_profile?.province_id);
      setDistrictId(data?.driver_profile?.district);
      setSubDistrictId(data?.driver_profile?.sub_district);
      setUrbanVillageId(data?.driver_profile?.urban_village);
      setPostalCodeId(data?.driver_profile?.postal_code_id);
      setSkillSetId(data?.fleet_detail?.skillset_id[0]);
      setTempCategoryId(data?.fleet_detail?.temperature_category_id);
      setPhotoDriver(data?.driver_profile?.photo);
      setDriverLicensePhoto(data?.fleet_detail?.license_image);
      setLicenseTypeId(data?.fleet_detail?.license_type);
      setMaritalStatus(data?.driver_profile?.marital_status);
      setDepotId(data?.depot_id);
      setUpdatedAt(data?.updated_at);
    }
  }, [location?.state?.id, token]);

  useEffect(() => {
    if (!depotId) {
      getDetailDeliveryAssociate();
      return;
    }
  }, [depotId, getDetailDeliveryAssociate]);

  const onChangeTab = useCallback((tabs) => {
    setTab(tabs);
  }, []);

  const clearCurrImg = useCallback(() => {
    setPhotoDriver("");
  }, []);

  const clearCurrImgDriverLicense = useCallback(() => {
    setDriverLicensePhoto("");
  }, []);

  const handleInputForm = useCallback((val, namespace) => {
    setFormInput((prevsValue) => ({
      ...prevsValue,
      [namespace]: val,
    }));
  }, []);

  const handleFormInputNumber = useCallback((val, namespace) => {
    setFormInputNumber((prevsValue) => ({
      ...prevsValue,
      [namespace]: val,
    }));
  }, []);

  const handleChangeDate = useCallback((evt, namespace) => {
    setFormInputDate((prevsValue) => ({
      ...prevsValue,
      [namespace]: evt,
    }));
  }, []);

  const handleChangePhone = useCallback((val, namespace) => {
    setFormInputPhone((prevsValue) => ({
      ...prevsValue,
      [namespace]: val,
    }));
  }, []);

  const handleChangeFormInputShiftStart = useCallback((evt, namespace) => {
    setFormInputShiftStart((prevsValue) => ({
      ...prevsValue,
      [namespace]: evt,
    }));
  }, []);

  const handleChangeFormInputShiftEnd = useCallback((evt, namespace) => {
    setFormInputShiftEnd((prevsValue) => ({
      ...prevsValue,
      [namespace]: evt,
    }));
  }, []);

  const FinalPhotoDriver = useMemo(() => {
    if (PhotoDriver || PhotoDriver !== "") {
      if (typeof PhotoDriver === "string") {
        return null;
      }
      return PhotoDriver[0]?.originFileObj;
    }
    return "";
  }, [PhotoDriver]);

  const FinalPhotoDriverLicense = useMemo(() => {
    if (PhotoDriverLicense || PhotoDriverLicense !== "") {
      if (typeof PhotoDriverLicense === "string") {
        return null;
      }
      return PhotoDriverLicense[0]?.originFileObj;
    }
    return "";
  }, [PhotoDriverLicense]);

  const handleSave = useCallback(async () => {
    const datas = {
      title: titleId ? titleId : 0,
      depot_id: depotId ? depotId : 0,
      ...FormInput,
      ...FormInputNumber,
      phone: FormInputPhone?.phone ? "+62-" + FormInputPhone?.phone : "",
      emergency_contact_no_hp: FormInputPhone?.emergency_contact_no_hp
        ? "+62-" + FormInputPhone?.emergency_contact_no_hp
        : "",
      date_of_birth: FormInputDate?.date_of_birth
        ? dayjs(FormInputDate?.date_of_birth).format("YYYY-MM-DD")
        : "",
      license_validity: FormInputDate?.license_validity
        ? dayjs(FormInputDate?.license_validity).format("YYYY-MM-DD")
        : "",
      shift_start_time: FormInputShiftStart
        ? FormInputShiftStart?.shift_start_hours +
          ":" +
          FormInputShiftStart?.shift_start_minutes
        : "",
      shift_end_time: FormInputShiftEnd
        ? FormInputShiftEnd?.shift_end_hours +
          ":" +
          FormInputShiftEnd?.shift_end_minutes
        : "",
      license_type: licenseTypeId,
      country: countryId,
      province: provinceId,
      district: districtId,
      sub_district: subDistrictId,
      urban_village: urbanVillageId,
      postal_code: postalCodeId,
      temperature_category_id: tempCategoryId,
      skill_set: { skill_set_id: [skillSetId] },
      updated_at: updatedAt,
      day_off: valueDayOff,
      vehicle_ownership: "yes",
      
      // daily_salary:Number(FormInput?.driver_profile?.daily_salary),
      // hourly_salary:Number(FormInput?.driver_profile?.hourly_salary),
      driver_photo: FinalPhotoDriver === null ? PhotoDriver : "",
      license_photo: FinalPhotoDriverLicense === null ? PhotoDriverLicense : "",
    };

    const formData = new FormData();
    const payload = JSON.stringify(datas);
    formData.append("delivery_associate", payload);
    formData.append("driver_photo", FinalPhotoDriver);
    formData.append("license_photo", FinalPhotoDriverLicense);

    const { status, message } = await DeliveryAssociateServices.updateData(
      token,
      location?.state?.id,
      formData
    );

    if (status) {
      setSuccessModalOpen(true);
      setMessagesSuccess(message);
    } else {
      setFailedModalOpen(true);
      setMessageFailed(message);
    }
  }, [
    FormInput,
    FormInputDate?.date_of_birth,
    FormInputDate?.license_validity,
    FormInputNumber,
    FormInputShiftEnd,
    FormInputShiftStart,
    FinalPhotoDriver,
    FinalPhotoDriverLicense,
    countryId,
    districtId,
    FormInputPhone,
    location?.state?.id,
    postalCodeId,
    provinceId,
    skillSetId,
    subDistrictId,
    tempCategoryId,
    licenseTypeId,
    titleId,
    token,
    updatedAt,
    urbanVillageId,
    valueDayOff,
    depotId,
    PhotoDriver,
    PhotoDriverLicense,
  ]);

  const _onOkSuccesAdd = () => {
    setSuccessModalOpen(false);
    navigate(ROUTES.DELIVERY_ASSOCIATE.LIST);
  };

  
  const handleFormInput = (val, namespace) => {
      const err = validationDA(namespace, val, t);
      // setFormError({
      //   ...FormError,
      //   ...err,
      // });
      if (namespace === "daily_salary") {
        setFormInput((prevsValue) => {
          return {
            ...prevsValue,
            [namespace]: Number(val),
            ["hourly_salary"]: val / 8,
          };
        });
      }else{
      setFormInput((prevsValue) => ({
        ...prevsValue,
        [namespace]: val,
      }));
    }
    }
  

  return (
    <>
      <Breadcumbs
        jmlLevel={3}
        menuLevel1={"Fleet"}
        menuLevel2={"Delivery Associate"}
        menuLevel3={`Edit ${nameDA}`}
      />
      <HeaderPages
        handleBack={btnBack}
        menuType={"add"}
        title={`Edit ${nameDA}`}
      />
      <div className="container-pages pb-10">
        <div className="flex flex-row gap-10">
          <div
            className={`font-roboto font-medium text-2xl cursor-pointer ${
              tab === 1
                ? "text-red-100 border-b-2 border-b-red-100"
                : "text-gray-100"
            }`}
            onClick={() => onChangeTab(1)}
          >
            Driver Profile
          </div>
          <div
            className={`font-roboto font-medium text-2xl cursor-pointer ${
              tab === 2
                ? "text-red-100 border-b-2 border-b-red-100"
                : "text-gray-100"
            }`}
            onClick={() => onChangeTab(2)}
          >
            Fleet Detail
          </div>
        </div>
        {tab === 1 ? (
          <TabDriverProfileOutsources
            FormInput={FormInput}
            FormInputShiftStart={FormInputShiftStart}
            FormInputShiftEnd={FormInputShiftEnd}
            PhotoDriver={PhotoDriver}
            setPhotoDriver={setPhotoDriver}
            clearCurrImg={clearCurrImg}
            countryId={countryId}
            setCountryId={setCountryId}
            provinceId={provinceId}
            setProvinceId={setProvinceId}
            districtId={districtId}
            setDistrictId={setDistrictId}
            subDistrictId={subDistrictId}
            setSubDistrictId={setSubDistrictId}
            urbanVillageId={urbanVillageId}
            setUrbanVillageId={setUrbanVillageId}
            postalCodeId={postalCodeId}
            setPostalCodeId={setPostalCodeId}
            gender={gender}
            titleId={titleId}
            setTitleId={setTitleId}
            valueDayOff={valueDayOff}
            setValueDayOff={setValueDayOff}
            FormInputDate={FormInputDate}
            handleInputForm={handleInputForm}
            maritalStatus={maritalStatus}
            setMaritalStatus={setMaritalStatus}
            handleChangeDate={handleChangeDate}
            FormInputPhone={FormInputPhone}
            handleChangePhone={handleChangePhone}
            handleChangeFormInputShiftStart={handleChangeFormInputShiftStart}
            handleChangeFormInputShiftEnd={handleChangeFormInputShiftEnd}
            handleFormInput={handleFormInput}
          />
        ) : (
          <TabFleetDetailOutsources
            PhotoDriverLicense={PhotoDriverLicense}
            setDriverLicensePhoto={setDriverLicensePhoto}
            licenseTypeId={licenseTypeId}
            setLicenseTypeId={setLicenseTypeId}
            FormInput={FormInput}
            depotId={depotId}
            skillSetId={skillSetId}
            setSkillSetId={setSkillSetId}
            FormInputNumber={FormInputNumber}
            FormInputDate={FormInputDate}
            clearCurrImgDriverLicense={clearCurrImgDriverLicense}
            tempCategoryId={tempCategoryId}
            setTempCategoryId={setTempCategoryId}
            handleInputForm={handleInputForm}
            handleFormInputNumber={handleFormInputNumber}
            handleChangeDate={handleChangeDate}
          />
        )}
      </div>
      <div className="btn-container">
        <button className="btn-cancel" onClick={btnBack}>
          Cancel
        </button>
        <button className="btn-next" onClick={handleSave}>
          Save
        </button>
      </div>
      <NotifFailedSaved
        visible={failedModalOpen}
        message={messageFailed}
        action={() => {
          setFailedModalOpen(false);
        }}
      />
      <NotifAddSuccess
        visible={successModalOpen}
        action={_onOkSuccesAdd}
        customMessage={messagesSuccess}
      />
    </>
  );
};

export default MainEditDeliveryAssociate;
